import * as React from "react"
import { cn } from "../../lib/utils"

export function WelcomeBanner({
  userName = "<username>",
  subtitle = "Track and manage all your loan applications in one place",
  className
}) {
  return (
    <div
      className={cn(
        "bg-neutral-1 px-12 py-4 border-b border-neutral-5",
        className,
      )}>
      <h1 className="text-4xl font-semibold mb-2">Hi, {userName}</h1>
      <p className="text-neutral-8 font-normal text-sm">{subtitle}</p>
    </div>
  )
}
